export default function Icon({ name, className = '', style, filled = false }) {
  const defaultStyle = filled
    ? { fontVariationSettings: "'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24", ...style }
    : style;

  return (
    <span className={`material-symbols-outlined ${className}`} style={defaultStyle}>
      {name}
    </span>
  );
}
